import { render, staticRenderFns } from "./lectoParamsDownTianzhun.vue?vue&type=template&id=e54c8298&scoped=true"
import script from "./lectoParamsDownTianzhun.vue?vue&type=script&lang=js"
export * from "./lectoParamsDownTianzhun.vue?vue&type=script&lang=js"
import style0 from "./lectoParamsDownTianzhun.vue?vue&type=style&index=0&id=e54c8298&prod&lang=less"
import style1 from "./lectoParamsDownTianzhun.vue?vue&type=style&index=1&id=e54c8298&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54c8298",
  null
  
)

export default component.exports